import React from "react";
import { FormattedMessage } from "react-intl";

import { Icon } from "../icon/Icon";
import ButtonLink from "../buttonLink/ButtonLink";

import "./RefreshButton.scss";

interface ButtonRefreshProps {
  onClick: () => void;
}

export const RefreshButton = ({ onClick }: ButtonRefreshProps) => {
  return (
    <ButtonLink onClick={onClick} className={"button-refresh__container"}>
      <FormattedMessage id={"retry_load_data"} />
      <Icon className="fa-regular fa-rotate button-refresh__icon" />
    </ButtonLink>
  );
};
